import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=d76eaa5e&scoped=true&"
import script from "./BackLink.vue?vue&type=script&lang=js&"
export * from "./BackLink.vue?vue&type=script&lang=js&"
import style0 from "./BackLink.vue?vue&type=style&index=0&id=d76eaa5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76eaa5e",
  null
  
)

export default component.exports